function setMPPasswordFormObserver(element, onShow, onHide) {
  if (!element) return null;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        if (mutation.target.id === 'showcase-password-container') {
          const showForm = !!mutation.target.querySelector('.sc-password-ui');
          if (showForm) {
            onShow();
          } else {
            onHide();
            observer.disconnect();
          }
        }
      }
    }
  });
  observer.observe(element, {
    childList: true,
    subtree: true,
  });
  return observer;
}

export default setMPPasswordFormObserver;
